// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"376":"fe8477f8","551":"45de37b2"}[chunkId] + ".chunk.js";
};